import React from 'react'
import Accordion from 'react-bootstrap/Accordion';

function FAQ() {
    let accordions_list = [];
    const data = [
        {
            question: 'Czy rejestracja jest płatna?',
            answer: <p>Nie, rejestracja, jak i posiadanie profilu jest całkowicie darmowe. Dołączając do serwisu otrzymujesz mnóstwo możliwości promowania swojej marki, pozyskiwania klientów i budowania wizerunku profesjonalnego prawnika. Zdecydowana większość funkcji serwisu jest bezpłatna a opcje dodatkowo płatne znajdziesz <a href="/dla-prawników/">tutaj</a>.</p>
        },
        {
            question: 'Czy obecność w serwisie jest zgodna z zasadami etyki prawnika?',
            answer: <p>Oczywiście, serwis służy Ci do informowania o swojej działalności, kontaktu z klientem i odpowiadania na jego zapytania. Możesz także publikować dla klienta artykuły, poradniki, korzystać z narzędzi do umawiania wizyt czy rozmów telefonicznych. Specprawnik zyskał wsparcie i patronat m.in. Okręgowej Izby Radców Prawnych w Poznaniu.</p>
        },
        {
            question: 'Jak w Specprawniku pozyskać klienta?',
            answer: <p>Możliwości jest mnóstwo, poczynając od odpowiadania na pytania na forum, przez krótkie 15-minutowe rozmowy telefoniczne czy publikacje artykułów w poradniku dla klienta. Serwis jest bardzo dobrze pozycjonowany w Google a zatem osoby szukające pomocy prawnej będą trafiały na Twój profil lub karty z Twoimi odpowiedziami na pytania. Sporo przydatnej wiedzy znajdziesz też na naszym fanpage'u oraz w krótkich filmikach instruktażowych na naszym kanale YouTube.</p>
        }, 
        {
            question: 'Czym Specprawnik różni się od innych serwisów dla prawnika?',
            answer: <p>Większość serwisów dla prawników w Polsce to po prostu miejsca, gdzie możesz założyć swoją wizytówkę internetową. Nie jest to zła metoda, ale raczej nieskuteczna, niewiele daje klientowi i nie promuje Twojej aktywności, wiedzy czy doświadczenia. W Specprawniku zaprezentujesz wszystkie swoje atuty i pozyskasz nowych klientów dla swojej kancelarii.</p>
        }
    ]

    data.forEach((item, index) => {
        const {question, answer} = item || ''
        accordions_list.push(
            <Accordion key={index} defaultActiveKey={index} alwaysOpen={false}>
                <Accordion.Item eventKey="0">
                    <Accordion.Header>{question}</Accordion.Header>
                    <Accordion.Body>{answer}</Accordion.Body>
                </Accordion.Item>
            </Accordion>
        )
    })
  return (
    <div id="faq">
        <h1>Najpopularniejsze pytania i odpowiedzi</h1>
        {accordions_list}
    </div>
  )
}

export default FAQ